<template>
  <div class="consult-box" v-if="visible">
    <div class="consult-content">
      <div class="consult-header">
        <div class="consult-title">
          <img src="@/assets/image/message.png" class="message-icon" />
          预约咨询
        </div>
        <div class="close-btn" @click="close">
          <img src="@/assets/image/header/close.png" />
        </div>
      </div>

      <div class="consult-body">
        <div class="consult-tip">欢迎填写以下信息，我们的顾问将尽快与您联系！</div>
        <el-form ref="formRef" :model="form" :rules="rules" size="default" style="width: 100%;">
          <el-form-item prop="name">
            <div class="input-wrapper">
              <img src="@/assets/image/username2.png" class="input-icon" />
              <el-input v-model="form.name" placeholder="姓名" />
            </div>
          </el-form-item>
          <el-form-item prop="company">
            <div class="input-wrapper">
              <img src="@/assets/image/messageCompany2.png" class="input-icon" />
              <el-input v-model="form.company" placeholder="公司名称" />
            </div>
          </el-form-item>
          <el-form-item prop="phone">
            <div class="input-wrapper">
              <img src="@/assets/image/messagePhone2.png" class="input-icon" />
              <el-input v-model="form.phone" placeholder="手机号" />
            </div>
          </el-form-item>
          <el-form-item prop="bizType">
            <div class="input-wrapper select-wrapper">
              <img src="@/assets/image/businessType.png" class="input-icon" />
              <el-select v-model="form.bizType" placeholder="请选择业务类型" style="width: 100%">
                <el-option value="等保定级" label="等保定级"></el-option>
                <el-option value="等保测评" label="等保测评"></el-option>
                <el-option value="安全产品" label="安全产品"></el-option>
                <el-option value="安全咨询" label="安全咨询"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item prop="content">
            <div class="input-wrapper textarea-wrapper">
              <img src="@/assets/image/content.png" class="input-icon" style="align-self: flex-start; margin-top: 0.2rem;" />
              <el-input type="textarea" v-model="form.content" placeholder="咨询内容" :rows="4" />
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="consult-footer">
        <div class="submit-btn" @click="submitForm">
          <img src="@/assets/image/message.png" class="message-icon" />
          提交预约
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import { ElForm, ElFormItem, ElInput, ElSelect, ElOption, ElMessage } from 'element-plus';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close', 'submit']);

const formRef = ref(null);

const form = ref({
  name: '',
  company: '',
  phone: '',
  bizType: '',
  content: ''
});

const rules = {
  name: [
    { required: true, message: '请输入姓名', trigger: 'blur' },
    { min: 2, max: 15, message: '姓名长度应为2-15个字符', trigger: 'blur' }
  ],
  // company: [
  //   { required: true, message: '请输入公司名称', trigger: 'blur' },
  //   { min: 2, max: 30, message: '公司名称长度应为2-30个字符', trigger: 'blur' }
  // ],
  phone: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号码', trigger: 'blur' }
  ],
  bizType: [
    { required: true, message: '请选择业务类型', trigger: 'change' }
  ],
  content: [
    { required: true, message: '请输入咨询内容', trigger: 'blur' },
    { min: 5, max: 500, message: '咨询内容长度应为5-500个字符', trigger: 'blur' }
  ]
};

const close = () => {
  emit('close');
};

const submitForm = () => {
  if (!formRef.value) return;
  
  formRef.value.validate((valid) => {
    if (valid) {
      // 提交表单
      emit('submit', form.value);
      
      // 重置表单
      formRef.value.resetFields();
      
      // 关闭窗口
      close();
    } else {
      ElMessage.error('请完善表单信息');
      return false;
    }
  });
};
</script>

<style lang="scss" scoped>
.consult-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .consult-content {
    width: 8rem;
    background-color: #fff;
    border-radius: 0.2rem;
    overflow: hidden;
    box-shadow: 0 0.05rem 0.2rem rgba(0, 0, 0, 0.1);
    max-width: 100%;
    
    .consult-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.3rem;
      background-color: #0077ff;
      color: #fff;

      .consult-title {
        display: flex;
        align-items: center;
        font-size: 0.36rem;
        font-weight: bold;
        
        .message-icon {
          width: 0.49rem;
          height: 0.41rem;
          margin-right: 0.2rem;
          filter: brightness(0) invert(1);
        }
      }

      .close-btn {
        cursor: pointer;
        width: 0.4rem;
        height: 0.4rem;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
          height: 100%;
          filter: brightness(0) invert(1);
        }
      }
    }

    .consult-body {
      padding: 0.4rem;

      .consult-tip {
        font-size: 0.28rem;
        color: #333;
        margin-bottom: 0.4rem;
        text-align: center;
      }

      :deep(.el-form-item) {
        margin-bottom: 0.3rem;
        width: 100%;
      }

      :deep(.el-form-item__error) {
        font-size: 0.16rem;
        padding-top: 0.02rem;
      }

      :deep(.el-form-item.is-error .input-wrapper) {
        border-color: #F56C6C;
      }

      :deep(.el-input__wrapper),
      :deep(.el-textarea__inner),
      :deep(.el-select .el-input__wrapper) {
        box-shadow: none;
        padding: 0;
        width: 100%;
      }

      :deep(.el-input__inner),
      :deep(.el-textarea__inner) {
        border: none;
        padding: 0.15rem 0;
        font-size: 0.28rem;
        width: 100%;
      }

      .input-wrapper {
        display: flex;
        align-items: center;
        border: 1px solid #e0e0e0;
        border-radius: 0.1rem;
        padding: 0.1rem 0.2rem;
        width: 100%;
        
        .input-icon {
          width: 0.31rem;
          height: 0.31rem;
          margin-right: 0.2rem;
          flex-shrink: 0;
        }

        &.textarea-wrapper {
          align-items: flex-start;
        }

        :deep(.el-input),
        :deep(.el-select) {
          width: 100%;
          flex: 1;
        }
      }
    }

    .consult-footer {
      padding: 0.3rem;
      display: flex;
      justify-content: center;
      
      .submit-btn {
        background-color: #0077ff;
        color: #fff;
        padding: 0.2rem 1rem;
        border-radius: 1rem;
        font-size: 0.3rem;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        
        .message-icon {
          width: 0.36rem;
          height: 0.36rem;
          margin-right: 0.15rem;
          filter: brightness(0) invert(1);
        }

        &:hover {
          background-color: #0066dd;
        }
      }
    }
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .consult-box {
    .consult-content {
      width: 90%;
      max-width: 8rem;
      
      .consult-header {
        padding: 0.25rem;
        
        .consult-title {
          font-size: 0.32rem;
        }
      }
      
      .consult-body {
        padding: 0.3rem;
        
        .consult-tip {
          font-size: 0.26rem;
        }
      }
      
      .consult-footer {
        .submit-btn {
          font-size: 0.28rem;
        }
      }
    }
  }
}
</style>